<template>
  <div v-if="article" class="news-detail-page">
    <section class="news-detail-hero reveal">
      <div class="news-detail-hero__media">
        <img :src="article.image" :alt="article.title">
      </div>
      <div class="news-detail-hero__overlay"></div>
      <div class="container news-detail-hero__content">
        <p class="news-detail-hero__date">{{ article.dateLabel }}</p>
        <h1>{{ article.title }}</h1>
        <p class="news-detail-hero__excerpt">{{ article.excerpt }}</p>
      </div>
    </section>

    <page-trail
      :items="[
        { label: $t('common.home'), to: '/' },
        { label: $t('nav.knowledge'), to: '/knowledge' },
        { label: article.title, to: $route.path }
      ]"
      :back-label="$t('common.backToNews')"
      :back-to="backToKnowledge"
    />

    <section class="news-detail-body reveal">
      <div class="container">
        <article class="news-detail-article">
          <p v-for="paragraph in article.body" :key="paragraph">{{ paragraph }}</p>
        </article>
        <router-link :to="backToKnowledge" class="news-detail-back">{{ $t('common.backToAllNews') }}</router-link>
      </div>
    </section>
  </div>
</template>

<script>
import site from '../mock/strongova'
import PageTrail from '../components/PageTrail.vue'
import { fetchPublicArticle, normalizeArticle } from '../api/public'

export default {
  name: 'NewsDetailPage',
  components: {
    PageTrail
  },
  data () {
    return {
      apiArticle: null
    }
  },
  computed: {
    article () {
      return this.apiArticle || site.knowledgePage.articles.find(item => item.slug === this.$route.params.slug) || null
    },
    backToKnowledge () {
      return { path: '/knowledge' }
    }
  },
  watch: {
    '$route.params.slug' () {
      this.loadArticle()
    }
  },
  mounted () {
    this.loadArticle()
  },
  methods: {
    loadArticle () {
      this.apiArticle = null
      fetchPublicArticle(this.$route.params.slug)
        .then(item => {
          this.apiArticle = normalizeArticle(item, site.knowledgePage.heroImage)
        })
        .catch(() => {
          this.apiArticle = null
          if (!this.article) {
            this.$router.replace('/knowledge')
          }
        })
    }
  }
}
</script>

<style>
.news-detail-page {
  color: #171411;
  background: #f6f1e9;
}

.news-detail-hero {
  position: relative;
  min-height: clamp(360px, 48vh, 520px);
  overflow: hidden;
}

.news-detail-hero__media,
.news-detail-hero__overlay {
  position: absolute;
  inset: 0;
}

.news-detail-hero__media img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.news-detail-hero__overlay {
  background:
    linear-gradient(90deg, rgba(0, 0, 0, 0.78) 0%, rgba(0, 0, 0, 0.42) 50%, rgba(0, 0, 0, 0.25) 100%),
    linear-gradient(180deg, rgba(0, 0, 0, 0.08) 0%, rgba(0, 0, 0, 0.62) 100%);
}

.news-detail-hero__content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  min-height: clamp(360px, 48vh, 520px);
  padding: 72px 0 56px;
  color: #f5f3ef;
}

.news-detail-hero__date {
  margin: 0 0 16px;
  font-size: 15px;
  letter-spacing: 0.08em;
  color: rgba(245, 243, 239, 0.68);
}

.news-detail-hero__content h1 {
  margin: 0 0 18px;
  max-width: 900px;
  font-size: clamp(30px, 3.6vw, 52px);
  font-weight: 400;
  line-height: 1.08;
}

.news-detail-hero__excerpt {
  margin: 0;
  max-width: 760px;
  font-size: clamp(16px, 1.5vw, 18px);
  line-height: 1.75;
  color: rgba(245, 243, 239, 0.82);
}

.news-detail-body {
  padding: clamp(64px, 8vw, 96px) 0 clamp(88px, 10vw, 112px);
}

.news-detail-article {
  max-width: 820px;
}

.news-detail-article p {
  margin: 0;
  font-size: clamp(17px, 1.5vw, 20px);
  line-height: 1.85;
  color: rgba(23, 20, 17, 0.84);
}

.news-detail-article p + p {
  margin-top: 24px;
}

.news-detail-back {
  display: inline-flex;
  align-items: center;
  min-height: 48px;
  margin-top: 48px;
  padding: 0 24px;
  border: 1px solid rgba(23, 20, 17, 0.22);
  color: #171411;
  text-decoration: none;
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;
}

.news-detail-back:hover {
  background: #171411;
  border-color: #171411;
  color: #f5f3ef;
}
</style>
